import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import DifyChat from './pages/DifyChat';
import TestApiKey from './pages/TestApiKey';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DifyChat />} />
        {/* Support for API key in the path */}
        <Route path="/chat" element={<DifyChat />} />
        {/* Test page for API key */}
        <Route path="/test-api-key" element={<TestApiKey />} />
        {/* Redirect old format to new format if needed */}
        <Route path="/api/:apiKey" element={<ApiKeyRedirect />} />
      </Routes>
      <RouteLogger />
    </Router>
  );
}

// Component to log route changes
function RouteLogger() {
  const location = useLocation();
  
  useEffect(() => {
    console.log('Current route:', location.pathname);
    console.log('Current search params:', location.search);
  }, [location]);
  
  return null;
}

// Component to handle redirects from path-based API keys to query parameter-based
function ApiKeyRedirect() {
  const params = new URLSearchParams(window.location.search);
  const path = window.location.pathname;
  const apiKey = path.split('/api/')[1];
  
  console.log('ApiKeyRedirect triggered');
  console.log('Path:', path);
  console.log('Extracted API Key:', apiKey);
  
  if (apiKey) {
    params.set('api_key', apiKey);
    console.log('Redirecting to:', `/chat?${params.toString()}`);
    return <Navigate to={`/chat?${params.toString()}`} replace />;
  }
  
  console.log('No API Key found, redirecting to home');
  return <Navigate to="/" replace />;
}

export default App;
